export default "__VITE_ASSET__5a10741b__"